import type { ComponentType } from 'react';
import { lazy } from 'react';

type IImportErrorHandler = (
  err: unknown,
  pageImport?: boolean,
) => Promise<void>;

let importErrorHandler: IImportErrorHandler | null = null;

export const setImportErrorHandler = (handler: IImportErrorHandler) => {
  importErrorHandler = handler;

  return () => {
    importErrorHandler = null;
  };
};

export const safeImport = async <T extends Promise<any>>(
  factory: () => T,
  pageImport?: boolean,
): Promise<Awaited<T>> => {
  try {
    return await factory();
  } catch (err) {
    if (importErrorHandler) {
      await importErrorHandler(err, pageImport);
    }
    throw err;
  }
};

export const safeReactLazy = <T extends ComponentType<any>>(
  factory: () => Promise<{ default: T }>,
) => {
  return lazy(() => safeImport(factory, true));
};
